export default "__VITE_ASSET__DMjwraE7__"